import { setSelectedLocation } from '../../utils/variables';

export function selectLocation(id) {
    removeAllSelectedLocation();

    setSelectedLocation(id);

    document
        .querySelector(
            `.location[data-location-id="${CSS.escape(id)}"]`
        )
        .classList.add('is-selected');

    document
        .querySelector('.locationContinue__btn')
        .classList.remove('disabled');
}

export function removeAllSelectedLocation() {
    setSelectedLocation('');

    document
        .querySelectorAll('.location')
        .forEach((i) => i.classList.remove('is-selected'));

    document.querySelector('.locationContinue__btn').classList.add('disabled');
}
